import { render } from "./InputDateTimeForm.vue?vue&type=template&id=2bfc6075&scoped=true"
import script from "./InputDateTimeForm.vue?vue&type=script&lang=js"
export * from "./InputDateTimeForm.vue?vue&type=script&lang=js"

import "./InputDateTimeForm.vue?vue&type=style&index=0&id=2bfc6075&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfc6075"]])

export default __exports__